import React, { useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";

import { Section } from "./Section";
import { SelectTemplate } from "./SelectTemplate";

import { audioSetVoice } from "../../../../../../store/modules/audio/actions";
import { getOptions, getSelectedVoice } from "../../../../../../store/modules/audio/selectors";

export function VoiceControl() {
  const dispatch = useDispatch();
  const currentVoice = useSelector(getSelectedVoice);
  const options = useSelector(getOptions);

  const handleOnChange = useCallback((value: string) => {
    dispatch(audioSetVoice(value));
  }, [dispatch]);

  return (
    <Section>
      <SelectTemplate
        title="Default Listening Language"
        value={currentVoice}
        options={options}
        handleOnChange={handleOnChange}
      />
    </Section>
  );
}
